import { requiredStrategy } from '../core';
import { taxIdNumberFormatStrategy } from './tax-id-number-format-strategy';
import { taxIdNumberLengthStrategy } from './tax-id-number-length-strategy';
import { taxIdNumberLogicStrategy } from './tax-id-number-logic-strategy';

export const taxIdNumberStrategy = (value: string) => {
  return (
    requiredStrategy(value) &&
    taxIdNumberLengthStrategy(value) &&
    taxIdNumberFormatStrategy(value) &&
    taxIdNumberLogicStrategy(value)
  );
};
